/** Tenant asset URLs served from the shared CloudFront distribution. */

/** CDN base. Overridable per deploy; defaults to the shared CloudFront host. */
const ASSET_CDN =
  (typeof import.meta.env.VITE_ASSET_CDN === 'string' && import.meta.env.VITE_ASSET_CDN) ||
  'https://d2wybwtt30d867.cloudfront.net';

/** Deployment segment used by placeholders (`test` | `sandbox` | `prod`). */
const ASSET_ENV =
  (typeof import.meta.env.VITE_ASSET_ENV === 'string' && import.meta.env.VITE_ASSET_ENV) ||
  'sandbox';

/**
 * Tenant placeholder image, e.g. `.../placeholders/sandbox/hy10/empty_state.png`.
 * `tenant` is the customer id the host sends on `init`. The host sends it
 * upper-cased (e.g. `HEFAME`) but the CDN folders are always lower-case, so we
 * lower-case the segment — otherwise the asset 403s and falls back to generic.
 */
export const placeholderUrl = (tenant: string, name = 'empty_state.png'): string =>
  `${ASSET_CDN}/placeholders/${ASSET_ENV}/${tenant.toLowerCase()}/${name}`;

/**
 * Tenant logo, e.g. `.../logos/hy10/logo-rectangle.png`. Logos are not
 * environment-scoped (unlike placeholders). Tenant segment is lower-cased to
 * match the CDN (the host sends an upper-cased customer id).
 */
export const logoUrl = (customerId: string, name = 'logo-rectangle.png'): string =>
  `${ASSET_CDN}/logos/${customerId.toLowerCase()}/${name}`;
